(() => {
  const init = () => {
    const groups = [...document.querySelectorAll('.more-nav--desktop .more-nav__details')];
    let hoverTimer;
    groups.forEach(detail => {
      detail.addEventListener('toggle', () => {
        if (detail.open) groups.forEach(other => { if (other !== detail) other.open = false; });
      });
      detail.addEventListener('mouseenter', () => {
        if (!matchMedia('(hover: hover) and (min-width: 1000px)').matches) return;
        clearTimeout(hoverTimer);
        groups.forEach(other => { if (other !== detail) other.open = false; });
        detail.open = true;
      });
      detail.addEventListener('mouseleave', () => {
        if (matchMedia('(hover: hover)').matches) hoverTimer = setTimeout(() => { detail.open = false; }, 160);
      });
      detail.addEventListener('keydown', event => {
        if (event.key === 'Escape') { detail.open = false; detail.querySelector('summary').focus(); }
      });
    });
    document.addEventListener('click', event => {
      if (!event.target.closest('.more-nav--desktop')) groups.forEach(detail => { detail.open = false; });
    });
    document.querySelectorAll('[data-contrast-toggle]').forEach(button => {
      button.addEventListener('click', () => {
        const active = document.body.classList.toggle('more-high-contrast');
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', active ? 'Standardkontrast wiederherstellen' : 'Höheren Kontrast aktivieren');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
